// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const editMutation = graphql`
	mutation InfoStringEditMutation($input: InfoStringEditInput!) {
		InfoStringEdit(input: $input) {
            error
			infoStringEdge {
				node {
					id
				}
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: editMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const {error, infoStringEdge} = response.InfoStringEdit;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, infoStringEdge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/mutations/InfoStringEditMutation.js